import React, { Suspense } from "react";

const LazyAcceptedJobOffers = React.lazy(() =>
  import("./accepted-job-offersInner").then((mod) => ({
    default: mod.AcceptedJobOffers,
  })),
);

export function AcceptedJobOffers() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center py-6">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <span className="h-2 w-2 rounded-full bg-gray-300 animate-pulse" />
            Loading schedule…
          </div>
        </div>
      }
    >
      <LazyAcceptedJobOffers />
    </Suspense>
  );
}

export default AcceptedJobOffers;
